import { createFileRoute } from '@tanstack/react-router';
import { VenueDetailPage } from '../../features/venues/VenueDetailPage.jsx';

function VenueRoute() {
  const { venueId } = Route.useParams();
  return <VenueDetailPage key={venueId} venueId={venueId} />;
}

export const Route = createFileRoute('/_app/venues/$venueId')({ component: VenueRoute });
